module.exports = __webpack_public_path__ + "img/suv.4ff4322b.svg";